import { Component } from '@angular/core';
import {  MenuController } from '@ionic/angular';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { Router, RouterEvent } from '@angular/router';

import { AuthService } from './services/auth/auth.service'
import { RouterService } from './services/router/router.service'
import { BackgroundMode } from '@ionic-native/background-mode/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent{

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router:Router,
    private menuController:MenuController,
    private authService:AuthService,
    private routerService:RouterService,
    private backgroundMode: BackgroundMode

  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {

      setTimeout(() => {
        this.splashScreen.hide();
      }, 1000);

      this.statusBar.styleDefault();
      this.splashScreen.hide();

      this.routerService.init();

      this.backgroundMode.enable();
    });
  }

  logout(){
    this.authService.logout();
    this.router.navigate(['login']);
  }


}
